import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINTS } from "Constants/endpoints";
import { getPincodesParams, getPincodesResponse } from "Interfaces/general";

import { cmsUrlQuery } from "./baseQuery";

export const cmsApi = createApi({
  reducerPath: "cmsApi",
  baseQuery: cmsUrlQuery,
  endpoints: (builder) => ({
    getPincodes: builder.query<getPincodesResponse[], getPincodesParams>({
      query: (body: getPincodesParams) => ({
        url: API_ENDPOINTS.GET_PINCODE,
        method: "GET",
        params: body,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token 64591335a441dd13cd179de5e37373668d0be449`,
        },
      }),
    }),
  }),
});

export const { useLazyGetPincodesQuery } = cmsApi;
